export enum EndPointName {
    getSpeakers = 'getSpeakers',
    setSpeaker = 'setSpeaker',
}
